import { render, staticRenderFns } from "./IframeSessionStats.vue?vue&type=template&id=6954bded&scoped=true"
import script from "./IframeSessionStats.vue?vue&type=script&lang=js"
export * from "./IframeSessionStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6954bded",
  null
  
)

export default component.exports